 /*
  * Pipeline Theme  *
  * Use this file to add custom Javascript to Pipeline.  */

  (function() {

    // Block beeapp WhatsApp script from loading
    var _insertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(newNode, refNode) {
      if (newNode.tagName === 'SCRIPT' && newNode.src && newNode.src.indexOf('beeapp.me') !== -1) {
        return newNode;
      }
      return _insertBefore.call(this, newNode, refNode);
    };

    var style = document.createElement('style');
    style.textContent = `
      .header__dropdown--js-open {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: all !important;
      }
      .grandparent--js-open > a,
      .grandparent--js-open {
        color: inherit !important;
      }
      .theme__header--dropdown-open {
        background-color: #fff !important;
        color: #000 !important;
      }
      .theme__header--dropdown-open a {
        color: #000 !important;
      }

      [data-header-wrapper] .theme__header {
        transition: background-color 0.3s ease, box-shadow 0.3s ease !important;
      }

      [id*="px-whatsapp"], [class*="px-whatsapp"],
      [id*="px-chat"], [class*="px-chat"],
      [id*="px_whatsapp"], [class*="px_whatsapp"] {
        display: none !important;
      }

      @media only screen and (min-width: 768px) {
        .collection__content {
          flex-flow: row !important;
        }
        .collection__content .collection__filters__wrapper {
          order: 1 !important;
          margin-right: 0 !important;
          margin-left: -250px !important;
        }
        .collection__content .collection__products {
          order: 2 !important;
        }
        .collection__filters__wrapper {
          margin-right: 0 !important;
          margin-left: -250px !important;
        }
        .drawer--visible.collection__filters__wrapper,
        .filters--default-visible.collection__filters__wrapper {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
        .collection__filters__inner {
          transform: translate3d(-100%, 0, 0) !important;
          padding-left: 10px !important;
          padding-right: var(--gutter) !important;
          margin-left: -10px !important;
          margin-right: 0 !important;
        }
        .drawer--visible .collection__filters__inner,
        .filters--default-visible .collection__filters__inner {
          transform: translate3d(0, 0, 0) !important;
        }
      }
    `;
    document.head.appendChild(style);

    window.suggaApplyHeaderBg = null;

    function initSuggaNav() {
      var wrapper = document.querySelector('[data-header-wrapper]');
      if (!wrapper) return;

      // Force wrapper always fixed at top — override any theme JS hiding
      wrapper.style.setProperty('position', 'fixed', 'important');
      wrapper.style.setProperty('top', '0', 'important');
      wrapper.style.setProperty('width', '100%', 'important');
      wrapper.style.setProperty('z-index', '9999', 'important');
      wrapper.style.setProperty('visibility', 'visible', 'important');
      wrapper.style.setProperty('opacity', '1', 'important');
      wrapper.style.setProperty('transform', 'none', 'important');

      var header = wrapper.querySelector('.theme__header');

      var isHovered = false;

      function applyHeaderBg() {
        var scrolled = (window.scrollY || window.pageYOffset) > 10;
        wrapper.classList.toggle('sugga-scrolled', scrolled);

        wrapper.style.setProperty('visibility', 'visible', 'important');
        wrapper.style.setProperty('opacity', '1', 'important');
        wrapper.style.setProperty('transform', 'none', 'important');

        if (header) {
          header.style.setProperty('transform', 'none', 'important');
          header.style.setProperty('visibility', 'visible', 'important');
          header.style.setProperty('opacity', '1', 'important');

          var dropdownOpen = !!document.querySelector('.header__dropdown--js-open');
          if (scrolled || isHovered || dropdownOpen) {
            header.style.setProperty('background', '#ffffff', 'important');
            header.style.setProperty('box-shadow', '0 2px 8px rgba(0,0,0,0.08)', 'important');
          } else {
            header.style.setProperty('background', 'transparent', 'important');
            header.style.setProperty('box-shadow', 'none', 'important');
          }
        }
      }

      wrapper.addEventListener('mouseenter', function() {
        isHovered = true;
        applyHeaderBg();
      });
      wrapper.addEventListener('mouseleave', function() {
        isHovered = false;
        applyHeaderBg();
      });

      window.suggaApplyHeaderBg = applyHeaderBg;
      window.addEventListener('scroll', applyHeaderBg, { passive: true });
      applyHeaderBg();
    }
    document.addEventListener('DOMContentLoaded', initSuggaNav);
    initSuggaNav();

    function fixDropdowns() {
      document.querySelectorAll('.grandparent').forEach(function(parent) {
        var dropdown = parent.querySelector('.header__dropdown');
        if (!dropdown) return;

        var parentLink = parent.querySelector('a[data-top-link]');
        var href = parentLink ? (parentLink.getAttribute('href') || '') : '';
        var text = parentLink ? parentLink.textContent.trim() : '';
        var isArchive = href.indexOf('archival') !== -1 || href.indexOf('archive') !== -1 ||
  text.toLowerCase() === 'archive';

        if (dropdown.parentNode !== document.body) {
          document.body.appendChild(dropdown);
        }

        dropdown.style.position = 'fixed';
        dropdown.style.left = '0';
        dropdown.style.right = '0';
        dropdown.style.width = '100vw';
        dropdown.style.maxWidth = '100vw';
        dropdown.style.transform = 'none';
        dropdown.style.zIndex = '9999';

        var header = document.querySelector('.theme__header');
        if (header) {
          dropdown.style.top = header.offsetHeight + 'px';
        }

        var inner = dropdown.querySelector('.header__dropdown__inner');
        if (inner) {
          inner.style.maxWidth = '1400px';
          inner.style.margin = '0 auto';
          inner.style.paddingLeft = '40px';
          inner.style.paddingRight = '40px';
          inner.style.display = 'flex';
          inner.style.justifyContent = 'space-between';

          if (isArchive && !inner.querySelector('.archive-spacer')) {
            var family = inner.querySelector('.dropdown__family--grandchild');
            if (family) {
              family.style.minWidth = 'auto';
              family.style.width = 'auto';
            }
            var spacer = document.createElement('div');
            spacer.className = 'archive-spacer';
            spacer.style.visibility = 'hidden';
            spacer.style.flexGrow = '1';
            inner.prepend(spacer);
          }
        }

        var hideTimer;

        function openDropdown() {
          clearTimeout(hideTimer);
          dropdown.classList.add('header__dropdown--js-open');
          parent.classList.add('grandparent--js-open');
          if (header) header.classList.add('theme__header--dropdown-open');
          if (window.suggaApplyHeaderBg) window.suggaApplyHeaderBg();
        }

        function closeDropdown() {
          hideTimer = setTimeout(function() {
            dropdown.classList.remove('header__dropdown--js-open');
            parent.classList.remove('grandparent--js-open');
            if (header) header.classList.remove('theme__header--dropdown-open');
            if (window.suggaApplyHeaderBg) window.suggaApplyHeaderBg();
          }, 150);
        }

        parent.addEventListener('mouseenter', openDropdown);
        parent.addEventListener('mouseleave', closeDropdown);
        dropdown.addEventListener('mouseenter', openDropdown);
        dropdown.addEventListener('mouseleave', closeDropdown);
      });
    }

    document.addEventListener('DOMContentLoaded', fixDropdowns);

  })();